import { defineMessages } from 'react-intl';

export default defineMessages({
    
    twiaRegistrationInstructions: {
        id: 'agent.registration.views.commissions.twiaRegistrationInstructions',
        defaultMessage: 'All the steps required to register with TWIA must be completed during one internet session, including clicking “Submit” on the final screen. If you leave the session before submitting your request, your information will not be saved. Once you successfully complete all the steps, you will be presented with a confirmation that your registration request is complete and has been received by TWIA.'
    },
    tfpaRegistrationInstruction: {
        id: 'agent.registration.views.commissions.tfpaRegistrationInstructions',
        defaultMessage: 'All the steps required to register with TFPA must be completed during one internet session, including clicking "Submit" on the final screen. If you leave the session before submitting your request, your information will not be saved. Once you successfully complete all the steps, you will be presented with a confirmation that your registration request is complete and has been received by TFPA'
    },
    AccountNumber: {
        id: 'agent.registration.Account Number',
        defaultMessage: 'Account Number',
    },
    ConfirmAccountNumber: {
        id: 'agent.registration.Confirm Account Number',
        defaultMessage: 'Confirm Account Number',
    },
    RoutingNumber: {
        id: 'agent.registration.views.Routing Number',
        defaultMessage: 'Routing Number',
    },
    RoutingNumberPlaceholder: {
        id: 'agent.registration.views.RoutingNumber.Placeholder',
        defaultMessage: '999999999',
    },
    AccountType: {
        id: 'agent.registration.views.Account Type',
        defaultMessage: 'Account Type',
    },
    CheckImage: {
        id: 'agent.registration.views.Check Image',
        defaultMessage: 'Check Image',
    },
    UploadInstructions: {
        id: 'agent.registration.views.UploadInstructions',
        defaultMessage: 'Upload copy of a blank check with \"VOID\" written on the face of the check',
    },
    uploadCheck: {
        id: 'agent.registration.views.Upload Check',
        defaultMessage: 'Upload Check',
    },
    SampleCheck: {
        id: 'agent.registration.views.Sample Check',
        defaultMessage: 'Sample Check',
    },
    DirectDepositTextTFPA: {
        id: 'agent.registration.views.DirectDepositTextTFPA',
        defaultMessage: 'For the account indicated above, I hereby authorize Texas FAIR Plan Association Insurance to initiate credit entries (deposits) and adjustments for any credit entries in error. This authority remains in full force and effect until Texas FAIR Plan Association Insurance has received notification from me of its termination in such manner as to afford the Association and my bank a reasonable opportunity to act. It is my responsibility to verify that funds transferred to my account are available for disbursement. Texas FAIR Plan Association Insurance  is not responsible for bank fees incurred due to my failure to verify the availability of deposited funds.',
    },
    DirectDepositTextTWIA: {
        id: 'agent.registration.views.DirectDepositTextTWIA',
        defaultMessage: 'For the account indicated above, I hereby authorize Texas Windstorm Insurance Association to initiate credit entries (deposits) and adjustments for any credit entries in error. This authority remains in full force and effect until Texas Windstorm Insurance Association has received notification from me of its termination in such manner as to afford the Association and my bank a reasonable opportunity to act. It is my responsibility to verify that funds transferred to my account are available for disbursement. Texas Windstorm Insurance Association is not responsible for bank fees incurred due to my failure to verify the availability of deposited funds.',
    },
    documentUploadFailed: {
        id: 'agent.registration.views.Document upload failed',
        defaultMessage: 'Document upload failed',
    },
    documentCannotUploaded: {
        id: 'agent.registration.views.Document service is not available',
        defaultMessage:
            'Document service is not available',
    },
    checkImageMissing: {
        id: 'agent.registration.views.Please upload check image',
        defaultMessage: 'Please upload at least one check image',
    },
    removeCheckTitle: {
        id: 'agent.registration.commissions.views. Remove Document',
        defaultMessage: 'Remove Document',
    },
    removeCheckMessage: {
        id: 'agent.registration.commissions.views. Are you sure you want to remove SampleCheck',
        defaultMessage: 'Are you sure you want to remove {documentname}',
    },

});
